class APIS {
	apis() {
		return {
			fetchLocations: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/client/locations'
			},
			bulkLocations: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client/bulk/location'
			},
			searchLocation: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/search/client/location'
			},
			addSingleLocation: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/client/location'
			},
			deleteLocation: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/delete/client/location'
			}
		};
	}
}

export default new APIS();
